import { render, staticRenderFns } from "./ApprovalCustomerChangesIndex.vue?vue&type=template&id=f44ccba4&"
import script from "./ApprovalCustomerChangesIndex.vue?vue&type=script&lang=js&"
export * from "./ApprovalCustomerChangesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports